import { AfterLoadEventHandler, CreateOptionsParams, ISpecializedCombo, useCombo } from '@hooks/useCombo';
import { MenuItem } from '@material-ui/core';
import { useOperadoraService } from '@services/OperadoraService';
import React from 'react';
import { EnumOperadoraStatus } from "./OperadoraStatus";

export enum EnumOperadora {
    None = 0,
    OI = 1,
    VIVO = 2,
    CLARO = 3,
    TIM = 4
}

export interface IOperadora {
    operadoraId: EnumOperadora

    operadoraStatusId: EnumOperadoraStatus

    nome: string
    codigo: string

    operadoraStatusNome: string
}

export type IComboOperadora = ISpecializedCombo<IOperadora>;

export function useOperadoraCombo (initialValue?: EnumOperadora) : IComboOperadora {
    const combo = useCombo<IOperadora>({
        value: initialValue
    });

    const operadoraService = useOperadoraService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((operadora, index) => {
            return <MenuItem key={index} value={operadora.operadoraId}>{params?.prefix}{operadora.nome}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback((afterLoad?: AfterLoadEventHandler<IOperadora>) => {
        combo.load(operadoraService.listarAtivas, afterLoad)
    }, [combo, operadoraService.listarAtivas]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}